<template>
  <div></div>
</template>

<script>
export default {
  mounted () {
    console.log('devtools Theme')
  }
}
</script>
